import { ethers } from 'ethers';
import { AVALANCHE_C_CHAIN_ID, AVALANCHE_FUJI_CHAIN_ID } from './chains/registry';

/**
 * Builds a JsonRpcProvider. On Avalanche L1s, fail fast on HTTP 429 so callers
 * can move to the next RPC URL instead of ethers retrying QuikNode up to 12
 * times while balances stay stuck at the initial "0".
 */
export const createJsonRpcProvider = (url: string, chainId: number) => {
  if (chainId === AVALANCHE_FUJI_CHAIN_ID || chainId === AVALANCHE_C_CHAIN_ID) {
    const request = new ethers.FetchRequest(url);
    request.setThrottleParams({ maxAttempts: 2 });
    request.retryFunc = async (_req, response) => response.statusCode !== 429;
    return new ethers.JsonRpcProvider(request, chainId);
  }
  return new ethers.JsonRpcProvider(url, chainId);
};
